import { styled } from '@mui/system'

const FormLoginBody = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	width: '26.875rem',
	backgroundColor: theme.palette.common.white,
	padding: '2rem 2.5rem 2.5rem',
	boxShadow: '0 1rem 1.875rem 0 rgba(0, 0, 0, 0.25)',
	borderRadius: '1rem',

	'>h1': {
		color: theme.palette.common.black,
	},

	'>form': {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
	},
}))

export { FormLoginBody }
